// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"29f9e885","453":"20092e99","455":"a9e08d91","977":"ea9babe5"}[chunkId] + ".chunk.js";
};